import {
  MONTH_LIST_REQUEST,
  MONTH_LIST_SUCCESS,
  MONTH_LIST_FAIL,
} from "../constants/monthConstants";
import api from "../core/api";

export const listMonth = () => async (dispatch, getState) => {
  try {
    dispatch({ type: MONTH_LIST_REQUEST });

    const { data } = await api.get(`/month`);

    var dt = data.Result;

    if (typeof dt == "string") {
      dispatch({
        type: MONTH_LIST_FAIL,
        payload: data.Result,
      });
    } else {
      dispatch({
        type: MONTH_LIST_SUCCESS,
        payload: data.Result,
      });
    }
  } catch (error) {
    dispatch({
      type: MONTH_LIST_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};
